// extracted by mini-css-extract-plugin
export default {"icon":"InfoTooltip_icon__jIjSF","tooltip":"InfoTooltip_tooltip__4VrUI","withWidth":"InfoTooltip_withWidth__yQ1ZQ"};